import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';

import heroIllustration from '@src/assets/images/catalog-hero-illustration.svg';
import { ROUTES } from '@src/routes';
import HomeOverlayHtmlSlot from '@src/plugin-slots/HomeOverlayHtmlSlot';
import { baseAppUrl } from '@src/utils';
import messages from './messages';

const HomeBanner = () => {
  const intl = useIntl();
  const registerUrl = baseAppUrl('/register');

  return (
    <section className="catalog-home-hero" data-testid="home-banner">
      <HomeOverlayHtmlSlot />
      <div className="catalog-home-hero__container">
        <div className="catalog-home-hero__copy">
          <span className="catalog-home-hero__eyebrow">{intl.formatMessage(messages.eyebrow)}</span>
          <h1 className="catalog-home-hero__title">
            <FormattedMessage
              {...messages.title}
              values={{
                highlight: (chunks: ReactNode) => <span>{chunks}</span>,
              }}
            />
          </h1>
          <p className="catalog-home-hero__description">
            {intl.formatMessage(messages.description)}
          </p>
          <div className="catalog-home-hero__actions">
            <a className="catalog-ui-button catalog-ui-button--primary catalog-ui-button--hero" href={registerUrl}>
              {intl.formatMessage(messages.primaryCta)}
            </a>
            <Link className="catalog-ui-button catalog-ui-button--secondary catalog-ui-button--hero" to={ROUTES.COURSES}>
              {intl.formatMessage(messages.secondaryCta)}
            </Link>
          </div>
        </div>

        <div className="catalog-home-hero__media">
          <img
            src={heroIllustration}
            alt={intl.formatMessage(messages.illustrationAlt)}
            className="catalog-home-hero__image"
          />
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
